import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { finalize, first } from "rxjs/operators";
import { DomSanitizer } from "@angular/platform-browser";
import { NgxSpinnerService } from "ngx-spinner";
import { FormIsValidDTO } from "src/app/parametrage/core/model/form-is-valid-dto";
import { FormulaireService } from "src/app/parametrage/core/service/formulaire.service";
import { ExecuterAllTask } from "src/app/mon-portefeuille/core/model/executer-all-task";
import { TaskService } from "src/app/mon-portefeuille/core/service/task.service";
import { GarantieDetail } from "src/app/parametrage/core/model/garanties/GarantieDetail";
import { GarantieService } from "src/app/parametrage/core/service/garantie.service";
import { GestionFichierService } from "src/app/core/services/business/service/gestion-fichier.service";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { AddDocumentGarantieComponent } from "./add-document-garantie/add-document-garantie.component";
import { EditGarantieDetailComponent } from "./edit-garantie-detail/edit-garantie-detail.component";
import { AddGarantieDetailComponent } from "./add-garantie-detail/add-garantie-detail.component";
import { NgbdModalConfirm } from "src/app/core/services/utils/modal-confirm";
import { ItemDetailComponent } from "./item-detail/item-detail.component";
import { GarantieDocument } from "src/app/parametrage/core/model/garanties/GarantieDocument";
import { SubItem } from "src/app/core/services/business/model/sub-item";

@Component({
  selector: "app-form-ajout-garantie",
  templateUrl: "./form-ajout-garantie.component.html",
  styleUrls: ["./form-ajout-garantie.component.scss"],
})
export class FormAjoutGarantieComponent implements OnInit {
  pressButton: Boolean = false;
  requestId: string;
  taskId: string;
  checkFormDTO: FormIsValidDTO;
  command: ExecuterAllTask = new ExecuterAllTask();
  form: FormGroup;
  name = "Angular 6";
  htmlContent = "";
  errorMessage: string;

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "8rem",
    minHeight: "5rem",
    placeholder: "Enter text here...",
    translate: "no",
    defaultParagraphSeparator: "p",
    defaultFontName: "Arial",
    toolbarHiddenButtons: [["bold"]],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: "redText",
        class: "redText",
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
  };

  request: Request;
  garanties: GarantieDetail[] = [];
  documentsClients: SubItem[] = [];
  documents: GarantieDocument[] = [];
  isRequiredDocExist: boolean = false;
  constructor(
    private modalService: NgbModal,
    private _garantieService: GarantieService,
    private _gestionFichierService: GestionFichierService,

    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _formulaireService: FormulaireService,
    private _taskService: TaskService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    public sanitizer: DomSanitizer
  ) {
    this.createForm();
  }
  createForm() {
    this.form = this.fb.group({
      commentaire: [null, Validators.compose([Validators.required])],
    });
  }
  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.requestId = params["requestId"];
      this.taskId = params["taskId"];
      this.checkIfFormIsValid(this.taskId);
      this.getGarantiesByRequestId(this.requestId);

      this.getDocumentGaranties(this.requestId);
      this.getEmptyDocumentsByRequest();
    });
  }
  getGarantiesByRequestId(requestId) {
    this._garantieService
      .getGarantiesByRequestId(requestId)
      .subscribe((data) => {
        this.garanties = data;
      });
  }

  getDocumentGaranties(requestId) {
    this._gestionFichierService
      .getDocumentGaranties(requestId)
      .subscribe((data) => {
        this.documentsClients = data;
      });
  }

  getEmptyDocumentsByRequest() {
    this._garantieService
      .getEmptyDocumentsByRequest(this.requestId)
      .subscribe((data) => {
        this.documents = data;
        if (this.documents && this.documents.length > 0) {
          const requiredDocs = this.documents.filter((doc) => doc.obligatoire);
          if (requiredDocs && requiredDocs.length > 0) {
            this.isRequiredDocExist = true;
          } else {
            this.isRequiredDocExist = false;
          }
        } else {
          this.isRequiredDocExist = false;
        }
      });
  }

  checkIfFormIsValid(taskId) {
    this._formulaireService.checkForm(taskId).subscribe(
      (data) => {
        this.checkFormDTO = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  executeTask(): void {
    this.command.taskId = this.taskId;
    this.command.requestId = this.requestId;
    this.pressButton = true;
    this.spinner.show();
    this._taskService
      .executerAllTask(this.command)
      .pipe(
        finalize(() => {
          this.spinner.hide();
        })
      )
      .subscribe(
        (data) => {
          this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
        },
        (error) => {
          console.log(error);
        }
      );
  }

  showGarantie(row) {
    const modalRef = this.modalService.open(ItemDetailComponent, {
      backdrop: "static",
      centered: true,
      scrollable: true,
      windowClass: "garantie-detail-modal",
    });
    modalRef.componentInstance.garantie = row;
    modalRef.componentInstance.requestId = this.requestId;

    modalRef.result.then(
      (result) => {
        // on close
        this.getGarantiesByRequestId(this.requestId);
        this.getDocumentGaranties(this.requestId);
        this.getEmptyDocumentsByRequest();
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  deleteGarantie(row) {
    //message en popup
    const modalConfirmRef = this.modalService.open(NgbdModalConfirm, {
      centered: true,
    });
    modalConfirmRef.componentInstance.title = "Suppression #" + row.id;
    modalConfirmRef.componentInstance.libelle = row.libelleNature;
    modalConfirmRef.componentInstance.queryMessage =
      "Etes-vous sûr de vouloir supprimer cette garantie";
    modalConfirmRef.componentInstance.description =
      '<span class="text-danger"> Cette opération sera définitive.</span>';
    modalConfirmRef.componentInstance.btnMessage = "Oui, supprimer";

    modalConfirmRef.result.then(
      (result) => {
        this.spinner.show();
        this._garantieService
          .deleteGarantieDetail(row.id)
          .pipe(
            finalize(() => {
              this.spinner.hide();
            })
          )
          .subscribe((data) => {
            this.getGarantiesByRequestId(this.requestId);
            this.getDocumentGaranties(this.requestId);
          });
      },
      (reason) => {
        console.log("reason", reason);
        //on dismiss
      }
    );
  }

  addGarantieDetail() {
    const modalRef = this.modalService.open(AddGarantieDetailComponent, {
      backdrop: "static",
      centered: true,
      scrollable: true,
      windowClass: "garantie-detail-modal",
    });
    modalRef.componentInstance.requestId = this.requestId;
    modalRef.result.then(
      (result) => {
        // on close
        this.getGarantiesByRequestId(this.requestId);
        this.getDocumentGaranties(this.requestId);
        this.getEmptyDocumentsByRequest();
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  editGarantieDetail(row: GarantieDetail) {
    const modalRef = this.modalService.open(EditGarantieDetailComponent, {
      backdrop: "static",
      centered: true,
      scrollable: true,
      windowClass: "garantie-detail-modal",
    });
    modalRef.componentInstance.requestId = this.requestId;
    modalRef.componentInstance.garantie = row;
    modalRef.result.then(
      (result) => {
        // on close
        this.getGarantiesByRequestId(this.requestId);
        this.getDocumentGaranties(this.requestId);
        this.getEmptyDocumentsByRequest();
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  addDocumentsGarantie(row: GarantieDetail) {
    const modalRef = this.modalService.open(AddDocumentGarantieComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      windowClass: "document-detail-modal",
    });
    modalRef.componentInstance.garantie = row;
    modalRef.componentInstance.requestId = this.requestId;
    modalRef.result.then(
      (result) => {
        console.log("result", result);
        // on close
        this.getDocumentGaranties(this.requestId);
        this.getEmptyDocumentsByRequest();
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }
}
